import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const RegionsRepository = {
  fetchAll: (payload) => {
    return Axios({
      url: SETTINGS.API_URL + "destinationRegions",
      method: "GET",
      params: {
        page: payload.page,
        size: payload.size,
        orderBy: payload.orderBy,
        orderDirection: payload.orderDirection,
        searchParams: payload.searchParams,
      },
    });
  },

  getAllWithoutPaging: () => {
    return Axios({
      url: SETTINGS.API_URL + "destinationRegions/all",
      method: "GET",
    });
  },
  get: (id) => {
    return Axios.get(`${SETTINGS.API_URL}destinationRegions/${id}`);
  },

  create: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}destinationRegions`,
      method: "POST",
      data: data,
    });
  },
  update: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}destinationRegions`,
      method: "PUT",
      data: data,
    });
  },

  delete: (id) => {
    return Axios.delete(`${SETTINGS.API_URL}destinationRegions/${id}`);
  },
};
